import React from "react";
import { DoctorAddress } from "../api/models";
import { Identifier } from "./Identifier";

interface AddressLabelProps {
  address?: DoctorAddress;
}

export function AddressLabel(props: AddressLabelProps) {
  const { address } = props;
  return (
    <span>
      {address?.name} {address?.postCode} {address?.street} <Identifier value={address?.id} />
    </span>
  );
}
